import { render, staticRenderFns } from "./DataSyncPanel.vue?vue&type=template&id=72960e82&scoped=true"
import script from "./DataSyncPanel.vue?vue&type=script&lang=js"
export * from "./DataSyncPanel.vue?vue&type=script&lang=js"
import style0 from "./DataSyncPanel.vue?vue&type=style&index=0&id=72960e82&prod&lang=scss&scoped=true"
import style1 from "./DataSyncPanel.vue?vue&type=style&index=1&id=72960e82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72960e82",
  null
  
)

export default component.exports